/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_BeraterInputs */

const en__field_berater = /** @type {(inputs: _Field_BeraterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Advisor`)
};

const de__field_berater = /** @type {(inputs: _Field_BeraterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Berater`)
};

/**
* | output |
* | --- |
* | "Advisor" |
*
* @param {_Field_BeraterInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const _field_berater = /** @type {((inputs?: _Field_BeraterInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_BeraterInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_berater(inputs)
	return de__field_berater(inputs)
});